module.exports = __webpack_public_path__ + "img/bg-2.f77458da.png";